<div class="row space-between">
    <h2 class="heading" i18>Select your Coach</h2>
    <rr-icon name="close" class="pointer" (click)="close()"></rr-icon>
</div>
<div class="col gap-16 w100">
    <div
        class="mentor row gap-8 w100 pointer align-center"
        *ngFor="let mentor of agentList"
        (click)="selectMentor(mentor)"
    >
        <img src="images/default-agent.png" alt="" />
        <div class="col gasp-8">
            <div class="name strong">{{ mentor.name }}</div>
            <div class="description tiny">{{ mentor.desc }}</div>
        </div>
    </div>
</div>
